import { GetRowIdParams, GridOptions } from '@ag-grid-community/core';

import { AgRawTooltip } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import { TableConstants } from '@shared/constants/table.constants';
import { Utils } from '@shared/utils/utils';

import { GridRowData } from '../types/site-budget-grid-row';

const DUMMY_LINE_SEPARATOR = '###LINE_SEPARATOR###';

export const SITE_BUDGET_DEFAULT_CONFIG: GridOptions<GridRowData> = {
  ...TableConstants.DEFAULT_GRID_OPTIONS.GRID_OPTIONS,
  ...TableConstants.DEFAULT_GRID_OPTIONS.EDIT_GRID_OPTIONS,
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    tooltipComponent: AgRawTooltip,
  },
  enableRangeSelection: true,
  fillHandleDirection: 'y',
  getRowId: (params: GetRowIdParams) => params.data.id,
  postSortRows: (params) => {
    const { nodes } = params;

    // Sort the nodes array in place
    nodes.sort((a, b) => {
      // Safely access the isNewAdjustment property from row data
      const aIsNew = !a.data?.paymentScheduleId;
      const bIsNew = !b.data?.paymentScheduleId;

      if (aIsNew && !bIsNew) return 1;

      if (!aIsNew && bIsNew) return -1;

      // If both are new or both are not new, maintain their relative order (return 0)
      return 0;
    });
  },
  processCellForClipboard: (params) => {
    if (params.column.getColId() === 'note') {
      /**
       * In ag-grid each new line is moved to a new row, so we need to replace new lines
       * with a dummy separator to enable pasting multiline strings
       */
      return params.value.replace(/\n/g, DUMMY_LINE_SEPARATOR);
    }

    return params.value;
  },
  processCellFromClipboard: (params) => {
    if (params.column.getId() === 'amount') {
      return Utils.castStringToNumber(params.value).toString();
    }

    if (params.column.getId() === 'note') {
      return params.value.replace(new RegExp(DUMMY_LINE_SEPARATOR, 'g'), '\n');
    }

    return params.value;
  },
  rowHeight: 40,
  rowSelection: 'multiple',
  suppressMenuHide: true,
  suppressRowClickSelection: true,
};
